module.exports = __webpack_public_path__ + "img/popup_header.daf3e09.png";